<template>
  <simple-activity :show-close-button="false">
    <template v-slot:primaryButton>
      <div class="d-flex justify-content-start m-auto pt-2" style="margin-left: 30px; width: 82% !important;">
        <h4 v-if="contactLang">{{ $tr('connectWith', 'Connect with:') }} {{ contact }} - {{ contactLang }}</h4>
        <h4 v-else>{{ $tr('connectWith', 'Connect with:') }} {{ contact }}</h4>
      </div>
    </template>
    <div class="pt-3 pb-3 pl-3">
      <div class="border width-check height-check m-auto" ref="messagesContainer"
           style="border-color: rgba(0,0,0,0.03); border-radius: 15px; padding: 10px; width: 84.5% !important;">

        <div
            v-for="(message, index) in messages"
            :key="message.id +':'+counter"
            ref="message"
            class="message-container my-3"
            :style="message.user === 'SilkPLM' ? 'align-items: center;' : 'align-items: flex-start;'"
        >
          <div class="w-100"
               v-if="hasUnreadMessages && userName!==message.userName && unreadMessagesCount > 0 && index === firstUnreadMessageIndex && !notificationDismissed">
            <div class="unread-messages-notification">
              <span class="line"></span>
              <strong class="unread-messages-text">{{ $tr('unreadMess', 'Unread messages') }} ({{
                  unreadMessagesCount
                }})</strong>
              <span class="line"></span>
            </div>
          </div>
          <MessageCenter v-if="message.user === 'SilkPLM' || message.user === 'SilkPLM'"
                         :message="message" :format-date="formatDate"></MessageCenter>
          <MessageRight v-else-if="message.userName && userName===message.userName" :message="message"
                        :format-date="formatDate"></MessageRight>
          <MessageLeft v-else-if="message.userName" :message="message" :format-date="formatDate"></MessageLeft>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <div class="d-flex justify-content-center align-items-center" style="width: 1000px">
        <b-button :disabled="inputDisabled || isBlocked" @click="triggerFileInput" class="send-button rounded mr-2 bg-primary">
          <font-awesome-icon class="text-light" :icon="['fal', 'paperclip']"></font-awesome-icon>
        </b-button>
        <input type="file" ref="fileInput" @change="_onSelected" style="display: none"/>
        <b-form-textarea
            ref="messageInput"
            :disabled="inputDisabled || isBlocked"
            type="text"
            v-model="newMessage"
            @keydown.enter="handleEnterKey"
            :placeholder="$tr('typeMess', 'Type a Message')"
            class="message-input"
        />
        <b-button @click="sendMessage" :disabled="!newMessage || newMessage.trim().length === 0 || isBlocked"
                  class="send-button rounded ml-2 bg-success">
          <font-awesome-icon class="text-light" :icon="['fal','paper-plane-top']" size="xs"></font-awesome-icon>
        </b-button>
      </div>
    </template>
  </simple-activity>
</template>


<script>
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity.vue";
import Activity from "@/activity/Activity";
import Rpc from "@/Rpc";
import FormsLoader from "@/components/forms/FormsLoader";
import ChatMessageBase from "@/server/com/silkplm/model/plm/chat/ChatMessageBase";
import ChatMessageInquiry from "@/server/com/silkplm/model/plm/chat/ChatMessageInquiry";
import TemporaryList from "@/components/forms/TemporaryList";
import ComplexActivity from "@/activity/templates/layouts/ComplexActivity.vue";
import FooterButton from "@/components/navbar/FooterButton.vue";
import FooterNavbar from "@/components/navbar/FooterNavbar.vue";
import tr from "@/utils/Tr";
import DashletsRpc from "@/DashletsRpc";
import FormHeader from "@/components/forms/FormHeader.vue";
import MessageLeft from "@/components/forms/renderers/MessageLeft.vue";
import MessageRight from "@/components/forms/renderers/MessageRight.vue";
import MessageCenter from "@/components/forms/renderers/MessageCenter.vue";
import PPSampleInquiry from "@/server/com/silkplm/model/plm/PPSampleInquiry";
import PPSamplesProduct from "@/server/com/silkplm/model/plm/PPSamplesProduct";
// import RoutingKeys from "@/server/RoutingKeys";
import ProductInquiry from "@/server/com/silkplm/model/plm/ProductInquiry";
import PlanningProduct from "@/server/com/silkplm/model/plm/PlanningProduct";
import RoutingKeys from "@/server/RoutingKeys";
import SessionManager from "@/utils/SessionManager";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";

const FORM_TYPE = ChatMessageBase;
let counter = 0;
export default {
  name: "Chat",
  components: {
    MessageCenter,
    MessageRight, MessageLeft, FormHeader, FooterNavbar, FooterButton, ComplexActivity, SimpleActivity
  },

  async mounted() {
    this.isBlocked = await Rpc.plm.services.marketPlace.services.roleSupplierCheckbox.SupplierRoleCheckboxChangeService.blockSendingMessages(this.masterId, this.masterFormConfig.formClassLong);
    this.isPPSampleInquiry = this.masterFormConfig.formClassLong === await PPSampleInquiry.getRemoteClass();
    this.isPPSampleProduct = this.masterFormConfig.formClassLong === await PPSamplesProduct.getRemoteClass();
    this.organization = await Rpc.OrganizationSetup.getSessionOrganizationInfo();
    this.userName = this.organization.name;

    if ((this.masterFormConfig.formClassLong === await ProductInquiry.getRemoteClass()) ||
        (this.masterFormConfig.formClassLong === await PPSampleInquiry.getRemoteClass())) {
      this.isBase = false;
      this.messages = await Rpc.plm.services.marketPlace.services.RemoteMessageMethodMarketService.filterChatMessageInquiry(this.masterId, this.masterFormConfig.formClassLong);
      this.contact = await Rpc.plm.services.marketPlace.services.RemoteMethodMarketService.getOrganizationInquiry(this.masterId, this.masterFormConfig.formClassLong);
      this.contactLang = await Rpc.plm.services.marketPlace.services.RemoteMethodMarketService.getSuppliersLanguage(this.masterId, this.masterFormConfig.formClassLong);
    } else if ((this.masterFormConfig.formClassLong === await PlanningProduct.getRemoteClass()) ||
        (this.masterFormConfig.formClassLong === await PPSamplesProduct.getRemoteClass())) {
      this.messages = await Rpc.plm.services.marketPlace.services.RemoteMessageMethodMarketService.filterChatMessageBase(this.masterId, this.masterFormConfig.formClassLong);
      this.isBase = true;
      this.contact = await Rpc.plm.services.marketPlace.services.RemoteMethodMarketService.getOrganizationBase(this.masterId, this.masterFormConfig.formClassLong);
      this.contactLang = await Rpc.plm.services.marketPlace.services.RemoteMethodMarketService.getSuppliersLanguage(this.masterId, this.masterFormConfig.formClassLong);
    }

    this.inputDisabled = this.messages.some(element => element.message === $tr("offerRemoved",
        "The offer has been removed. Messages cannot be sent. Please contact the organization:") + " "  + this.contact + ".");
    let user = await Rpc.Users.getSessionUserInfo();
    if (user.firstName) {
      this.user = user.firstName + " " + user.lastName;
    } else {
      this.user = user.login;
    }
    if (this.messages) {
      await this.loadUnreadMessages();
    }
    if (this.isBase) {
      this.$subscribe(RoutingKeys.RK_CHAT_CHANGE_OFFER_BASE_COMPANIES + "." + this.masterId, async message => {
        let messageEntity = new ChatMessageBase();
        await messageEntity.load(message.messageId);
        if ((messageEntity.pPSampleProduct !== null && messageEntity.pPSampleProduct === this.masterId) ||
            (messageEntity.planningProductId !== null && messageEntity.planningProductId === this.masterId)) {
          messageEntity.creationDate = new Date(messageEntity.creationDate);
          this.messages = [...this.messages, messageEntity];
          this.messagesLength = this.messages.length;
          this.notificationDismissed = false;
          await this.loadUnreadMessages();
          this.$nextTick(() => {
            this.scrollToLastMessage({ behavior: 'smooth', block: 'center' });
          });
          if(SessionManager.userOnTabConfig.get(SessionManager.applicationUser.id)===
              this.detailsConfig.formConfig.formClassLong){
            await this.dismissNotificationAfterDelay();
          }        }
      });
    } else {
      this.$subscribe(RoutingKeys.RK_CHAT_CHANGE_OFFER_SUPPLIERS + "." + this.masterId, async message => {
        let messageEntity = new ChatMessageInquiry();
        await messageEntity.load(message.messageId);
        if ((messageEntity.sampleInquiryId !== null && messageEntity.sampleInquiryId === this.masterId) ||
            (messageEntity.productInquiryId !== null && messageEntity.productInquiryId === this.masterId)) {
          messageEntity.creationDate = new Date(messageEntity.creationDate);
          this.messages = [...this.messages, messageEntity];
          this.messagesLength = this.messages.length;
          this.notificationDismissed = false;
          await this.loadUnreadMessages();
          this.$nextTick(() => {
            this.scrollToLastMessage({ behavior: 'smooth', block: 'center' });
          });
          if(SessionManager.userOnTabConfig.get(SessionManager.applicationUser.id)===
              this.detailsConfig.formConfig.formClassLong){
            await this.dismissNotificationAfterDelay();
          }
        }
      });
    }

    this.$nextTick(() => {
      this.scrollToUnreadMessage();
    });

    await this.dismissNotificationAfterDelay();

    this.$nextTick(() => {
      if (this.$refs.messageInput && typeof this.$refs.messageInput.focus === 'function') {
        this.$refs.messageInput.focus();
      }
    });
  },

  props: {
    isBlocked: {default: false},
    isPPSampleInquiry: {default: false},
    isPPSampleProduct: {default: false},
    hasWriteAccessToMaster: {default: false},
    context: {default: null},
    detailsMode: {type: String, default: ""},
    detailsTemporaryList: {type: TemporaryList, default: null},
    detailsConfig: {default: null},
    masterId: {default: null},
    mode: {default: null},
    temporaryList: {default: null},
    masterFormConfig: {default: null},
    metaStatus: {default: null},
    callingFormConfig: {default: null},
    filter: {default: null},
    selectionSize: 0,
    showMultiSelect: false,
    tabName: "",
  },


  methods: {
    tr,
    ...Activity.methods,

    getTitle() {
      return $tr('messagesTitle', 'Messages');
    },

    isCurrentUser(userName) {
      return this.userName === userName;
    },

    async loadUnreadMessages(){
      let instant = "";
      if (this.isBase) {
        instant = await DashletsRpc.UnreadMessages.getInstantOfLastUpdatedMessageBase(this.masterId, this.masterFormConfig.formClassLong);
      } else {
        instant = await DashletsRpc.UnreadMessages.getInstantOfLastUpdatedMessageInquiry(this.masterId, this.masterFormConfig.formClassLong);
      }

      this.unreadMessagesCount = this.messages
          .filter(message => !this.isCurrentUser(message.userName))
          .filter(message => new Date(message.creationDate) > instant)
          .length;

      this.hasUnreadMessages = this.unreadMessagesCount > 0;

      this.firstUnreadMessageIndex = this.messages.findIndex(message =>
          !this.isCurrentUser(message.userName) &&
          (new Date(message.creationDate) > instant)
      );
    },

    async dismissNotificationAfterDelay() {
      if (this.notificationTimeout) {
        clearTimeout(this.notificationTimeout);
      }
      this.notificationTimeout = setTimeout(async () => {
        this.notificationDismissed = true;
        this.resetUnreadMessagesCount();
        let data = {}
        data.notification = false;
        data.entityId = this.masterId;
        EventBus.$emit(Events.unreadMessagesNotifications, data);
        if (this.notificationDismissed) {
          if (this.isBase) {
            await DashletsRpc.UnreadMessages.updateOrInsertMessageStateInBase(this.masterId, this.masterFormConfig.formClassLong);
          } else {
            await DashletsRpc.UnreadMessages.updateOrInsertMessageStateInInquiry(this.masterId, this.masterFormConfig.formClassLong);
          }
        }
      }, 3000);
    },

    formatDate(date) {
      if (date) {
        const days = [$tr('sunday', 'Sunday'), $tr('monday', 'Monday'), $tr('tuesday', 'Tuesday'),
          $tr('wednesday', 'Wednesday'), $tr('thursday', 'Thursday'), $tr('friday', 'Friday'), $tr('saturday', 'Saturday')];
        const dayName = days[date.getDay()];

        const day = date.getDate().toString().padStart(2, '0');
        const months = [$tr('janu', 'January'), $tr('febru', 'February'), $tr('march', 'March'), $tr('april', 'April'), $tr('may', 'May'), $tr('june', 'June'),
          $tr('july', 'July'), $tr('augu', 'August'), $tr('sept', 'September'), $tr('octo', 'October'), $tr('nove', 'November'), $tr('dec', 'December')];
        const monthName = months[date.getMonth()];

        const year = date.getFullYear();

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day} ${monthName} ${year}, ${hours}:${minutes}`;
      }
      return null;
    },

    handleEnterKey(event) {
      if (event.shiftKey) {
        return;
      }
      event.preventDefault();
      this.sendMessage();
    },

    async sendMessage() {
      if (this.newMessage && this.newMessage.trim().length > 0) {
        if (this.isBase) {
          await Rpc.plm.services.marketPlace.services.RemoteMessageMethodMarketService.sendMessageToInquiry(this.masterId, this.newMessage,
              this.user, this.masterFormConfig.formClassLong);
          this.$forceUpdate();
          await DashletsRpc.UnreadMessages.updateOrInsertMessageStateInBase(this.masterId, this.masterFormConfig.formClassLong);
        } else {
          await Rpc.plm.services.marketPlace.services.RemoteMessageMethodMarketService.sendMessageToBase(this.masterId, this.newMessage, this.user,
              this.masterFormConfig.formClassLong);
          this.$forceUpdate();
          await DashletsRpc.UnreadMessages.updateOrInsertMessageStateInInquiry(this.masterId, this.masterFormConfig.formClassLong);
        }
        this.newMessage = "";
        this.$nextTick(() => {
          this.scrollToLastMessage();
        });
      }
    },

    scrollToLastMessage(options = { behavior: 'smooth', block: 'end' }) {
      this.$nextTick(() => {
        const messages = this.$refs.message;

        if (!messages || (Array.isArray(messages) && messages.length === 0)) return;

        const lastMessage = Array.isArray(messages)
            ? messages[messages.length - 1]
            : messages;

        if (lastMessage && typeof lastMessage.scrollIntoView === 'function') {
          lastMessage.scrollIntoView(options);
        }
      });
    },

    scrollToUnreadMessage() {
      this.$nextTick(() => {
        if (!this.hasUnreadMessages || this.firstUnreadMessageIndex < 0) {
          this.scrollToLastMessage();
          return;
        }

        const messages = this.$refs.message;

        if (!messages) return;

        const targetMessage = Array.isArray(messages)
            ? messages[this.firstUnreadMessageIndex]
            : messages;

        if (targetMessage && typeof targetMessage.scrollIntoView === 'function') {
          targetMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },

    resetUnreadMessagesCount() {
      if (this.notificationDismissed) {
        this.unreadMessagesCount = 0;
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    async _onSelected() {
      if (!this.$refs['fileInput'].files || !this.$refs['fileInput'].files[0]) {
        return;
      }
      this.file = this.$refs['fileInput'].files[0];
      if (this.isBase) {
        await Rpc.plm.services.marketPlace.services.RemoteMethodMarketService.sendAttachmentFromChatForSuppliers(this.masterId, this.file, this.masterFormConfig.formClassLong);
      } else {
        await Rpc.plm.services.marketPlace.services.RemoteMethodMarketService.sendAttachmentFromChatForBase(this.masterId, this.file, this.masterFormConfig.formClassLong);
      }
    },
  },

  watch: {
    "messages": async function (val) {
      let instant = "";
      if (this.isBase) {
        instant = await DashletsRpc.UnreadMessages.getInstantOfLastUpdatedMessageBase(this.masterId, this.masterFormConfig.formClassLong);
      } else {
        instant = await DashletsRpc.UnreadMessages.getInstantOfLastUpdatedMessageInquiry(this.masterId, this.masterFormConfig.formClassLong);
      }

      this.unreadMessagesCount = this.messages
          .filter(message => !this.isCurrentUser(message.userName))
          .filter(message => new Date(message.creationDate) > instant)
          .length;

      this.hasUnreadMessages = this.unreadMessagesCount > 0;

      this.firstUnreadMessageIndex = this.messages.findIndex(message =>
          !this.isCurrentUser(message.userName) &&
          (new Date(message.creationDate) > instant)
      );
      this.$forceUpdate();
      this.resetUnreadMessagesCount();
    },
    refreshIfIsOpen: async function (val) {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.scrollToUnreadMessage();
          if (this.$refs.messageInput && typeof this.$refs.messageInput.focus === 'function') {
            this.$refs.messageInput.focus();
          }
        });
      });


      await this.dismissNotificationAfterDelay();

    }
  },


  data : function() {
    return {
      FORM_TYPE,
      formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
      userName: {default: null},
      messages: [],
      contact: null,
      contactLang: null,
      newMessage: '',
      isBase: true,
      organization: null,
      user: '',
      file: null,
      refreshIfIsOpen: false,
      loading: null,
      lastSentMessageDate: null,
      hasUnreadMessages: false,
      unreadMessagesCount: 0,
      firstUnreadMessageIndex: 0,
      notificationDismissed: false,
      inputDisabled: false,
      attachment: null,
      messagesLength: 0,
      counter: counter++,
      notificationTimeout: null,
    }
  },


}
</script>

<style scoped>

.message-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  height: auto;
  box-sizing: border-box;
}

.unread-messages-notification {
  color: #d88e20;
  font-size: 14px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
}

.unread-messages-text {
  padding: 0 10px;
  background-color: white;
  z-index: 1;
}

.line {
  flex-grow: 1;
  height: 2px;
  background-color: #d88e20;
  margin: 0 10px;
}


.message-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  outline: none;
  resize: none;
}

.send-button {
  font-size: 24px;
  padding: 0 10px;
  cursor: pointer;
  border: none;
  height: 38px;
}

.send-button:focus {
  outline: none;
}

.width-check {
  width: 75%;
  margin-left: 30px;
}

.height-check {
  min-height: 100%;
  height: auto;
}


@media screen and (max-width: 530px) {
  .width-check {
    width: 100%;
    margin-left: 0;
  }
  .height-check{
    min-height: 100%;
  }

}
</style>